"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var react_router_dom_1 = require("react-router-dom");
var teamsnap_ui_1 = require("@teamsnap/teamsnap-ui");
var ProgramCard = function (_a) {
    var program = _a.program;
    return (React.createElement(teamsnap_ui_1.Panel, { mods: "program-card", key: "program-card-" + program.id },
        React.createElement("div", { className: "u-padMd u-xs-padSidesLg u-flex u-flexAlignItemsCenter u-flexJustifyBetween" },
            React.createElement("div", { className: "Grid" },
                React.createElement("div", { className: "Grid-cell u-xs-size1of2" },
                    React.createElement("div", { className: "u-spaceBottomSm u-fontSizeXl" },
                        React.createElement(react_router_dom_1.Link, { to: "/organizations/" + program.organizationId + "/programs/" + program.id }, program.name)),
                    React.createElement("p", { className: "u-colorGrey" }, program.description)),
                React.createElement("div", { className: "Grid-cell u-xs-size1of2 u-textRight u-flex u-flexCol u-flexJustifyBetween" },
                    React.createElement("div", { className: "button-list" },
                        React.createElement(react_router_dom_1.Link, { to: "/organizations/" + program.organizationId + "/programs/" + program.id + "/edit" },
                            React.createElement(teamsnap_ui_1.Button, { color: "", icon: "edit", iconPosition: "left" }, "Edit"))))))));
};
exports.default = ProgramCard;
//# sourceMappingURL=program-card.js.map